import { Component, OnInit, ViewEncapsulation, Input, HostBinding, Injector } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Module } from 'projects/common/model/ModuleModel';
import { AbstractComponent } from '../abstract.component';

class YoutubeVideoData {
  youtube_video_key: string;
  youtube_video_loop?: boolean;
  youtube_video_auto_play?: boolean;
  background: string;
}

@Component({
  selector: 'youtube-embeded',
  template: `    
    <div class="complete-background">
      <div class="embed-container">
        <iframe width="100%" [src]="videoUrl" title="YouTube video player"
                frameborder="0"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; autoplay;"
                allowfullscreen>
        </iframe>
      </div>
    </div>
  `,
  styleUrls: ['./youtube-embeded-video.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class YoutubeEmbededVideoComponent extends AbstractComponent implements OnInit {
  public static MODULE_ID: string = 'YoutubeEmbeddedVideoModule';
  @HostBinding('style.--background-url') backgroundImageURL: string;

  @Input() override module: Module<YoutubeVideoData>;

  private static BASE_VIDEO_URL: string = "https://www.youtube.com/embed/";
  private configParams: string = "?controls=1&modestbranding=1&color=white&iv_load_policy=3&rel=0";
  videoUrl: SafeResourceUrl;

  constructor(injector: Injector, private sanitizer: DomSanitizer) {
    super(injector);
  }

  ngOnInit(): void {
    this.configParams += `&autoplay=${this.module.data.youtube_video_auto_play ? 1 : 0}${this.module.data.youtube_video_auto_play ? '&mute=1' : ''}`;
    if (this.module.data.youtube_video_loop) {
      this.configParams += '&loop=1&playlist=' + this.module.data.youtube_video_key;
    }
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(YoutubeEmbededVideoComponent.BASE_VIDEO_URL + this.module.data.youtube_video_key + this.configParams);
    this.backgroundImageURL = 'url(https://media.staticontent.com/media/pictures/' + this.module.data.background + ')';
  }

  getModuleId(): string {
    return YoutubeEmbededVideoComponent.MODULE_ID;
  }
}


